import { colors } from '../../colors';
var address = {
  arrowColor: colors.rust,
  textColor: colors.graphite,
  borderColor: colors.graphite,
  backgroundColor: colors.whiteish
};
export default address;